export default __webpack_public_path__ + "static/media/circle3.1.b2552604.svg";